import Vue from 'vue'
import VueRouter from 'vue-router'
import home from '../views/Home.vue'
import documentation from '../views/Documentation.vue'
import auth from '../views/Auth.vue'
import profile from '../views/Profile.vue'
import redirectSpotify from '../views/redirectSpotify.vue'
import playlistSelection from '../views/PlaylistSelection.vue'
import listified from '../views/Listified.vue'
import editCurrentFavs from '../views/EditCurrentFavs.vue'


import { checkAuth, checkUserPlaylists, checkUserProfile } from '../plugins/vuetify/helpers/router-helper'

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    name: "home",
    component: home
  },
  {
    path: '/documentation',
    name: "documentation",
    component: documentation
  },
  {
    path: '/auth',
    name: "auth",
    component: auth
  },
  {
    path: '/profile',
    name: "profile",
    component: profile,
    meta: { requiresAuth: true, requiresProfile: true, requiresPlaylists: true }
  },
  {
    path: '/redirectSpotify',
    name: "redirectSpotify",
    component: redirectSpotify
  },
  {
    path: '/playlistSelection',
    name: "playlistSelection",
    component: playlistSelection,
    meta: { requiresAuth: true, requiresProfile: false, requiresPlaylists: true }
  },
  {
    path: '/listified',
    name: "listified",
    component: listified,
    meta: { requiresAuth: true, requiresProfile: true, requiresPlaylists: false }
  },
  {
    path: '/editCurrentFavs',
    name: "editCurrentFavs",
    component: editCurrentFavs,
    meta: { requiresAuth: true, requiresProfile: true, requiresPlaylists: false }
  }
]

const router = new VueRouter({
  mode: 'history',
  routes,
  scrollBehavior: function (to) {
    if (to.hash) {
      return {
        selector: to.hash,
        offset: { x: 0, y: 60 }
      }
    }
  },
})

router.beforeEach(async (to, from, next) => {

  let redirectPath = ""
  let query = {}

  let authState = {}
  let profileState = {}
  let playlistsState = {}

  //requiresAuth?
  if (to.meta.requiresAuth) {
    authState = await checkAuth()
    if (!authState.state && authState.msg === "auth-needed") {
      redirectPath = "/redirectSpotify"
      query.redirect = to.path
    } else if (!authState.state && authState.msg === "no-connection") {
      console.log("Failed to connect to API!")
      redirectPath = "/"
    } else if (!authState) {
      console.log("Unknown error during auth")
    }
  }

  //Further steps only when authed
  if (authState.state) {
    //requiresProfile?
    if (to.meta.requiresProfile) {
      profileState = await checkUserProfile()
      if (!profileState.state && profileState.msg === "no-connection") {
        console.log("Failed to connect to API!")
        redirectPath = "/"
      }
    }

    //requiresPlaylists?
    if (to.meta.requiresPlaylists) {
      playlistsState = await checkUserPlaylists()
      if (!playlistsState.state && playlistsState.msg === "no-connection") {
        console.log("Failed to connect to API!")
        redirectPath = "/"
      }
    }
  }

  

  //If editCurrentFav site is accessed
  if(to.path === "/editCurrentFavs") {
    if (Vue.prototype.$globalState.listify) {
      if (!Vue.prototype.$globalState.listify.editTracks) {
        let Notify = {
          duration: 4000,
          type: "error",
          headline: "Edit Current Favourites Playlist",
          message: "No Tracks to edit...",
        };
        Vue.prototype.$globalState.addNotification(Notify);
        redirectPath = "/listified"
      }
    } else {
      redirectPath = "/"
    }
  }
  

  //If listified site is accessed
  if(to.path === "/listified") {
    //Check if listifyInfo is available
    if(!Vue.prototype.$globalState.listifyInfo) {
      console.log("Access Forbidden");
      redirectPath = "/"
    }
  }


  //if every data is fetched
  if (redirectPath) {
    if (query) {
      next({ path: redirectPath, query: query })
    } else {
      next({ path: redirectPath })
    }
  } else {
    next()
  }
})

export default router
